import { Box, Stack, Typography, useTheme } from '@mui/material'
import { useMemo } from 'react'

import { pathToMarketingSiteBuilder } from '~/features/marketing/utils'
import useIsPartner from '~/features/partners/hooks/useIsPartner/v2'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { ESiteImagesTypes } from '~/features/partners/models'
import { getImgUrlByType } from '~/features/partners/utils'
import { EChatbotTheme } from '~/features/settings/models'
import { EMarketingClientPath } from '~/models/api'
import { store } from '~/store'
import rem, {
  getWhiteOrBlackTextColorByBackground,
  isColorLight,
} from '~/utils/ui'

function LogoAndFooterText() {
  const theme = useTheme()
  const isPartner = useIsPartner()
  const chatbotLayout = store((state) => state.chatbot.layout)

  const { partner } = usePartnerCentralized()

  const footerBackgroundColor = useMemo(() => {
    return theme.palette.mainFont
  }, [theme])

  const logoUrl = getImgUrlByType(
    isColorLight(footerBackgroundColor)
      ? ESiteImagesTypes.logoDark
      : ESiteImagesTypes.logoLight,
    partner,
  )

  const getFooterTextColor = () => {
    return getWhiteOrBlackTextColorByBackground(footerBackgroundColor, theme)
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography
        sx={{
          fontSize: rem(16),
          textAlign: 'end',
          lineHeight: rem(12),
          whiteSpace: 'nowrap',
          color:
            chatbotLayout?.selection.theme === EChatbotTheme.linkView
              ? getFooterTextColor()
              : theme.palette.common.white,
        }}
      >
        Powered by
      </Typography>
      <Box
        component="img"
        src={logoUrl}
        alt="Logo"
        sx={{
          width: {
            xxxs: isPartner ? rem(90) : rem(80),
            md: isPartner ? rem(110) : rem(80),
          },
          height: '100%',
          maxHeight: rem(50),
          cursor: 'pointer',
          mixBlendMode: 'screen',
        }}
        onClick={() =>
          window.open(
            isPartner
              ? '/'
              : pathToMarketingSiteBuilder(EMarketingClientPath.home),
            '_blank',
          )
        }
      />
    </Stack>
  )
}

export default LogoAndFooterText
